export { B as BREAKPOINT_SIZES } from './breakpoints-1c783da5.js';
import { E as Env } from './index-d3a9c8bd.js';
import { g as getUrl } from './icon.utils-98a76768.js';
import './tokens-aa5444cd.js';

/**
 * Bucket path that points to location where assets are deployed.
 * Develop bucket: https://static-ns-nl-data.fep-o.cla.ns.nl
 * Staging bucket: https://static-ns-nl-data.fep-s.cla.ns.nl
 * Production bucket: https://static-ns-nl-data.fep-p.cla.ns.nl
 */
const ABSOLUTE_BUCKET_PATH = 'https://static-ns-nl-data.fep-p.cla.ns.nl/apps/nessie';

const APP_VERSION = Env.appVersion;
const getNessieAssetPath = () => {
    return `${ABSOLUTE_BUCKET_PATH}/${APP_VERSION}/`;
};

/**
 * Enum representing the types of assets that can be prefetched.
 */
var AssetType;
(function (AssetType) {
    AssetType["Icons"] = "icons";
    AssetType["IconsDetail"] = "icons-detail";
    AssetType["Assets"] = "assets";
})(AssetType || (AssetType = {}));
/**
 * Object containing the URLs for different types of assets.
 */
const assetTypeUrls = {
    [AssetType.Icons]: 'assets/icons',
    [AssetType.IconsDetail]: 'assets/icons-detail',
    [AssetType.Assets]: 'assets',
};
// Create a cache object
const cache = {};
// Create a link element
const link = document.createElement('link');
link.rel = 'prefetch';
link.crossOrigin = 'true';
document.head.appendChild(link);
/**
 * Prefetches assets by updating the href of a link element to the asset URL.
 * If the asset is already in the cache, it returns early.
 * @param assets - An array of objects containing the name and type of the asset to prefetch.
 * @throws An error if the asset type is invalid.
 */
const prefetchAssets = (assets) => {
    assets.forEach(({ name, type }) => {
        if (!(type in assetTypeUrls)) {
            throw new Error(`Invalid asset type: ${type}, type must be one of ${Object.keys(assetTypeUrls)}`);
        }
        const assetURL = getUrl(name, assetTypeUrls[type]);
        // If the asset is already in the cache, return early
        if (cache[assetURL]) {
            return;
        }
        // Update the href of the link element
        link.href = assetURL;
        // Add the asset to the cache
        cache[assetURL] = true;
    });
};

export { getNessieAssetPath, prefetchAssets };
